<div class="badge__frame">
    <img class="badge__logo" src="./assets/images/NBRC-Logo-Animation-Once.gif">
    <div class="badge__body" *ngIf="validBadge()">
        <h1>{{person.firstName}} {{person.middleName}} {{person.lastName}}<span *ngIf="person.suffix">, {{person.suffix}}</span></h1>
        <h5 class="credential__title w3-animate-left">Credentials Earned</h5>
        <hr>
        <div class="credential" *ngFor="let item of person.certifications">               
            <div class="credential__text-wrap">
                <i class="icon icon--check-circle credential__icon credential__icon--completed"></i>
                <h3 *ngIf="needsBaseCredential(item.credentialCode)" class="credential__title w3-animate-left">{{person.baseCredential[0].baseCredentialCode}}-{{item.credentialCode}}</h3>
                <h3 *ngIf="!needsBaseCredential(item.credentialCode)" class="credential__title w3-animate-left">{{item.credentialCode}}</h3>
                <div class="data-list data-list--inline">
                    <div class="data-item data-item--inline ">
                        <h2 class="data-item__label label">Earned</h2>
                        <div *ngIf="!altCredentialDate(item, '1901-01-01') && !altCredentialDate(item,'1909-09-09')" class="data-item__value">{{item.certificationDate | amDateFormat: 'L'}}</div>
                        <div *ngIf="altCredentialDate(item,'1909-09-09')">N/A</div>
                        <div *ngIf="altCredentialDate(item,'1901-01-01')">Please contact our office regarding your credential date.</div>
                    </div>
                    <div *ngIf="item.expirationDate !== null" class="data-item data-item--inline">
                        <h2 class="data-item__label label">Expires</h2>
                        <div class="data-item__value">{{item.expirationDate | amDateFormat: 'L'}}</div>
                    </div>
                    <div *ngIf="item.credentialCode === 'RRT'" class="data-item data-item--inline">
                        <h2 class="data-item__label label">Registry #</h2>
                        <div class="data-item__value">{{item.registryNumber}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div><p style="font-size: smaller;">Credentials expire on the date indicated and will not be recognized as valid if this individual does not complete the
            Credential Maintenance Program requirements. If a expired date is not listed,
            the credential does not expire and the individual is not required to participate in the Credential Maintenance Program.
            </p>
        </div>
    </div>
    <div *ngIf="!validBadge()" class="badge__body">
        <p>This badge is not available due to one of the following reasons:</p>
        <ul>
            <li>practitioner payment not current</li>
            <li>practitioner credential(s) expired</li>
            <li>invalid badge link</li>
        </ul>
    
        <p>Please contact the practitioner or the NBRC at 913.895.4900 for more information.</p>
    </div>
    <div style="display: flex;">
        <div class="badge__address">
            <!-- <span class="badge-lungs__text badge-lungs__mobile">10801 Mastin St., Ste. 300, Overland Park, KS 66210</span> -->
            <div class="badge-lungs--flex"><img class="badge-lungs__image " src="/assets/images/lungs.png"> <span class="badge-lungs__text">913.895.4900 </span></div>
            <div class="badge-lungs--flex"><img class="badge-lungs__image" src="/assets/images/lungs.png"> <span class="badge-lungs__text">nbrc-info@nbrc.org </span></div> 
            <div class="badge-lungs--flex"><img class="badge-lungs__image" src="/assets/images/lungs.png"> <span class="badge-lungs__text">nbrc.org </span></div>
        </div>
        <img class="badge__seal" src="/assets/images/NBRC-Seal.jpg">
    </div>
</div>